import * as React from 'react';
import style from './RPCApiRequestDisplay.scss';
import { Rectangle } from '../../../../PageElements/Rectangle/Rectangle';
import { TryItOutRPCButton } from './TryItOutRPCButton/TryItOutRPCButton';

const removeSpaceAndNumbersFromMethodName = (txt = '') =>
  txt.replace(/\s+|\d+/g, '');

export const RPCApiRequestDisplay = ({
  methodName,
  rpcRequestName,
  rpcResponseName,
  artifactId,
  serviceName,
}) => {
  return (
    <Rectangle className={style.rpcSyntaxContainer}>
      <div className={style.syntax}>
        <RPC />
        {` ${removeSpaceAndNumbersFromMethodName(methodName)}`}
        <Param withBrackets>{rpcRequestName}</Param>
        {' returns '}
        <Param withBrackets>{rpcResponseName}</Param>
        <OrangeParam>;</OrangeParam>
      </div>
      <TryItOutRPCButton
        methodName={methodName}
        artifactId={artifactId}
        serviceName={serviceName}
      />
    </Rectangle>
  );
};

const RPC = () => {
  return <span className={style.rpcPrefix}>rpc</span>;
};

const OrangeParam = ({ children }) => (
  <span className={style.bracket}>{children}</span>
);

const Param = ({ children, withBrackets }) => {
  let param = <span className={style.rpcParam}>{children}</span>;
  if (withBrackets) {
    param = (
      <React.Fragment>
        <OrangeParam className={style.bracket}>(</OrangeParam>
        {param}
        <OrangeParam className={style.bracket}>)</OrangeParam>
      </React.Fragment>
    );
  }
  return param;
};
